import * as yup from "yup"

export const createServiceLevelSchema = yup.object({
  times: yup
    .array()
    .of(
      yup
        .object({
          incidentPriorityId: yup
            .number()
            .nullable()
            .notRequired(),
          serviceLevelTypeId: yup
            .number()
            .typeError("El tipo de nivel de servicio es requerido")
            .oneOf([1, 2], "El tipo de nivel de servicio no es válido")
            .nullable()
            .notRequired(),
          days: yup
            .number()
            .typeError("No es un día válido")
            .min(0, "El día debe ser un número positivo")
            .nullable()
            .notRequired(),
          hours: yup
            .number()
            .typeError("No es una hora válida")
            .min(0, "No es una hora válida")
            .max(23, "No es una hora válida")
            .nullable()
            .notRequired(),
          minutes: yup
            .number()
            .typeError("No es un minuto válido")
            .min(0, "No es un minuto válido")
            .max(59, "No es un minuto válido")
            .nullable()
            .notRequired(),
          seconds: yup
            .number()
            .typeError("No es un segundo válido")
            .min(0, "No es un segundo válido")
            .max(59, "No es un segundo válido")
            .nullable()
            .notRequired(),
          firstResponseHours: yup
            .number()
            .typeError("No es una hora válida")
            .min(0, "No es una hora válida")
            .max(23, "No es una hora válida")
            .nullable()
            .notRequired(),
          firstResponseMinutes: yup
            .number()
            .typeError("No es un minuto válido")
            .min(0, "No es un minuto válido")
            .max(59, "No es un minuto válido")
            .nullable()
            .notRequired(),
          firstResponseSeconds: yup
            .number()
            .typeError("No es un segundo válido")
            .min(0, "No es un segundo válido")
            .max(59, "No es un segundo válido")
            .nullable()
            .notRequired(),
        })
    )
});
